export default __webpack_public_path__ + "static/media/cmbh-project@2x.4c5d657c.jpg";